import React, { forwardRef } from 'react'

const InfoField = forwardRef((props, ref) => {
  const { title, value } = props;
    return (
      <div>
      <span>{title}</span>
      <p className="text-gray-700 dark:text-gray-200 font-semibold">
        {value}
      </p>
    </div>
    )
})

export default InfoField